import { Mail } from "lucide-react";
import { FAQS, CONTACT_EMAIL } from "../data";
import { Breadcrumb } from "../Layout";

export default function Faq() {
  return (
    <div className="mx-auto max-w-4xl px-4 py-14 sm:px-8">
      <Breadcrumb items={[{ label: "Accueil", to: "/" }, { label: "FAQ" }]} />
      <p className="tag-mono mb-4 text-[#E4C5B3]">Questions fréquentes</p>
      <h1 className="font-display text-4xl font-medium leading-[1.1] tracking-tight sm:text-5xl">
        Les réponses aux questions des prothésistes ongulaires
      </h1>
      <p className="mt-6 max-w-2xl text-base leading-relaxed text-zinc-400 sm:text-lg">
        Catalysation, utilisation des embouts, marques proposées, commande : l'essentiel est ci-dessous.
        Pour tout le reste, écrivez-nous.
      </p>

      <div className="mt-12 space-y-4">
        {FAQS.map((f, i) => (
          <details key={f.q} data-testid={`faq-item-${i + 1}`} className="faq-item group border border-white/10 bg-[#15151C]">
            <summary className="flex cursor-pointer list-none items-center justify-between gap-4 p-6 font-display text-lg font-medium text-[#F8F7F4] transition-colors hover:text-[#E4C5B3] [&::-webkit-details-marker]:hidden">
              {f.q}
              <span aria-hidden="true" className="faq-plus font-display text-2xl text-[#E4C5B3] transition-transform duration-300">
                +
              </span>
            </summary>
            <p className="px-6 pb-6 text-sm leading-relaxed text-zinc-400 sm:text-base">{f.a}</p>
          </details>
        ))}
      </div>

      <div className="mt-12 border border-[#E4C5B3]/25 bg-[#1C1C26] p-8 sm:p-10">
        <h2 className="font-display text-2xl font-medium tracking-tight">Votre question n'y est pas ?</h2>
        <p className="mt-4 max-w-2xl text-base leading-relaxed text-zinc-400">
          Décrivez-nous votre pratique ou la référence recherchée : nous vous répondrons personnellement.
        </p>
        <a href={`mailto:${CONTACT_EMAIL}`} data-testid="faq-contact-cta" className="btn-primary mt-6">
          <Mail size={16} aria-hidden="true" /> {CONTACT_EMAIL}
        </a>
      </div>
    </div>
  );
}
